import {Component, OnInit} from "@angular/core";
import {Helpers} from "../../services/Helpers";
import {SiteServices} from "../../services/siteservices";

export interface HtmlMarketingElement {
    ProviderId: number,
    CssFormats: CssFormats[],
    TargetPlatforms: string,
    TargetPlatformsArray: string[],
}

export interface CssFormats {
    Key: string,
    Value: string
}

@Component({
    selector: 'providerhtmlmarketingelementsapp',
    templateUrl: '/templates/get/ProviderHtmlMarketingElements/providerhtmlmarketingelements_list',
})
export class ProviderHtmlMarketingElementsListComponent implements OnInit {
    providerID: number = null;
    htmlMarketingElements: HtmlMarketingElement[] = [];
    htmlMarketingContainerNames: string[] = [];

    allTargetPlatform: string[] =
        [
            // ROKSH
            'ROKSH_DESKTOP_HUN',
            'ROKSH_DESKTOP_AUT',
            'ROKSH_MOBILE_HUN',
            'ROKSH_MOBILE_AUT',

            // ALDI
            'ALDI_HUN',
            'ALDI_CHE',

            // MOL
            'MOL_MOBILE_HUN'];
    
    loadInProgress: boolean = false;

    constructor(public siteServices: SiteServices) {
    }
    
    public ngOnInit() {
        this.loadInProgress = true;
        const inputProviderID = parseInt(Helpers.getParameterByName('providerid'));
        
        if (inputProviderID && inputProviderID > 0)
        {
            this.providerID = inputProviderID;
        }
        this.refresh();
        this.loadInProgress = false;
    }
    
    private refresh(){
        this.siteServices.provider_Execute(
            'PROVIDER',
            'GETHTMLMARKETINGELEMENTS',
            this.providerID,
            (data) => {
                this.htmlMarketingElements = data.TagObject.HtmlMarketingElements.map(e => ({
                    ...e,
                    TargetPlatformsArray: e.TargetPlatforms
                        ? e.TargetPlatforms.split(',').map(x => x.trim())
                        : []
                }));
                this.htmlMarketingContainerNames = data.TagObject.HtmlMarketingContainerNames;
            }
        );
    }

    clearTargetPlatforms(row: any) {
        row.TargetPlatformsArray = [];
    }

    saveHtmlMarketingElements(){
        this.loadInProgress = true;

        this.htmlMarketingElements.forEach(e => {
            const targetPlatforms = e.TargetPlatformsArray;
            e.TargetPlatforms =
                targetPlatforms && targetPlatforms.length > 0
                ? targetPlatforms.join(',')
                    : null;
        });

        this.siteServices.provider_Execute(
            'PROVIDER',
            'SAVEHTMLMARKETINGELEMENTS',
            this.htmlMarketingElements,
            (data) => {
                this.refresh();
                this.siteServices.success(data.TagObject)
                this.loadInProgress = false;
            }
        );
    }

    addElement(){
        const newItem: HtmlMarketingElement = {
            ProviderId: this.providerID,
            CssFormats: [],
            TargetPlatforms: null,
            TargetPlatformsArray: []
        };
        this.htmlMarketingElements.push(newItem);
    }

    removeItem(elementIndex: number) {
        this.htmlMarketingElements.splice(elementIndex, 1);
    }
    
    addCssItem(elementIndex: number) {
        const currentElement = this.htmlMarketingElements[elementIndex];
        const newCssFormat = { Key: '', Value: ''};
        
        currentElement.CssFormats.push(newCssFormat);
    }

    removeCssItem(elementIndex: number, cssIndex: number) {
        const currentElement = this.htmlMarketingElements[elementIndex];
        currentElement.CssFormats.splice(cssIndex, 1);
    }
}
